import WorktypesGrid from "../../components/grids/WorktypesGrid";
import AddWorkTypeForm from "../../components/FormComps/Worktypes/AddWorkTypeForm";
import EditWorkTypeForm from "../../components/FormComps/Worktypes/EditWorkTypeForm";

import { useState, useEffect } from "react";
import { useToast } from "../../contexts/ToastContext";

import {
  Drawer,
  DrawerContent,
  DrawerNavigation,
} from "@progress/kendo-react-layout";
import { FaTimesCircle } from "react-icons/fa";
import {
  submitWorktype,
  getWorktypes,
  deleteWorktype,
} from "../../data/worktypeData";
import { worktypesGrid, postWorktypeTypes } from "../../data/interfaces";
import { canEditArea } from "../../helpers/areaAccess";

import "../Styles.css";

interface WorktypesProps {
  allowedRoutes?: string[];
}

const Worktypes = (props: WorktypesProps) => {
  // WorkTypes.Manage or an administrator (see areaAccess.ts). The server
  // enforces the same.
  const canEdit = canEditArea(props.allowedRoutes, "WorkTypes");
  const [worktypeData, setWorktypeData] = useState<worktypesGrid[]>([]);
  const [expanded, setExpanded] = useState(false);
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [addFormVisible, setAddFormVisible] = useState(false);
  const [worktypeId, setWorktypeId] = useState(0);
  const { showToast } = useToast();

  const handleAddForm = () => {
    setAddFormVisible((prevState) => (!prevState ? true : true));
    setEditFormVisible(false);
    handleExpanded();
  };

  const handleEditForm = (id: number) => {
    setWorktypeId(id);
    setEditFormVisible((prevState) => (!prevState ? true : true));
    setAddFormVisible(false);
    handleExpanded();
  };

  // const updateWorktypeHandler = (dataItem: any, id: number) => {
  //    updateWorktype(dataItem, id)
  //       .then(() => {
  //          const fetchData = async () => {
  //             const worktypeData = await getWorktypes();
  //             setWorktypeData(worktypeData)
  //          }
  //          fetchData()
  //       })
  //    handleExpanded()
  //    showToast('Worktype succesfully updated', 'success');
  // };

  const newWorktypeHandler = (dataItem: postWorktypeTypes) => {
    submitWorktype(dataItem).then(() => {
      const fetchData = async () => {
        const worktypeData = await getWorktypes();
        setWorktypeData(worktypeData);
      };
      fetchData();
    });
    handleExpanded();
    showToast("Worktype succesfully added", "success");
  };

  useEffect(() => {
    const fetchData = async () => {
      const worktypeData = await getWorktypes();
      setWorktypeData(worktypeData);
    };

    fetchData();
  }, []);

  const deleteWorktypeHandler = (id: number) => {
    deleteWorktype(id)
      .then(() => {
        setWorktypeData((prevData) =>
          prevData.filter((worktype) => worktype.worktypeId !== id)
        );
      })
      .catch((error) => {
        // Handle error, for example, showing a toast message about the failure
        showToast("Error deleting worktype", "error");
      });
    handleExpanded();
    showToast("Worktype succesfully deleted", "success");
  };

  const handleExpanded = () => {
    setExpanded((prevState) => !prevState);

    if (editFormVisible) {
      setEditFormVisible(false);
    }
    if (addFormVisible) {
      setAddFormVisible(false);
    }
  };

  const handleSelect = () => {
    setExpanded(false);
  };

  return (
    <div>
      <Drawer
        expanded={expanded}
        position={"end"}
        width={750}
        mode="overlay"
        animation={{
          duration: 400,
        }}
        onOverlayClick={handleExpanded}
        onSelect={handleSelect}
      >
        <DrawerContent>
          <DrawerNavigation>
            {addFormVisible && (
              <>
                <div className="form__title__container">
                  <h1 className="form__title">Add Worktype</h1>
                  <FaTimesCircle
                    className="closeform"
                    onClick={handleExpanded}
                  />
                </div>
                <div className="form__wrapper">
                  <AddWorkTypeForm onWorkTypeSubmit={newWorktypeHandler} />
                  {/* <WorkTypeForm
                    onSuccess={handleExpanded}
                  /> */}
                </div>
              </>
            )}

            {editFormVisible && (
              <>
                <div className="form__title__container">
                  <h1 className="form__title">{canEdit ? "Edit Worktype" : "Worktype"}</h1>
                  <FaTimesCircle
                    className="closeform"
                    onClick={handleExpanded}
                  />
                </div>
                <EditWorkTypeForm
                  // onEditSubmit={updateWorktypeHandler}
                  onWorktypeId={worktypeId}
                  onWorktypeDelete={deleteWorktypeHandler}
                  canEdit={canEdit}
                />
                {/* <WorkTypeForm
                    onSuccess={handleExpanded}
                    onWorktypeId={worktypeId}
                  /> */}
              </>
            )}
          </DrawerNavigation>

          <WorktypesGrid
            onAddToggle={handleAddForm}
            canAdd={canEdit}
            onEditToggle={handleEditForm}
            onData={worktypeData}
          />
        </DrawerContent>
      </Drawer>
    </div>
  );
};

export default Worktypes;
